<template>
  <div>
    <blog-article v-if="$route.params.slug" :slug="$route.params.slug" />
    <blog-index v-else />
  </div>
</template>

<script>
import BlogArticle from '@/components/blog/BlogArticle'
import BlogIndex from '@/components/blog/BlogIndex'

export default {
  name: 'BlogPage',
  components: { BlogArticle, BlogIndex },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>
